import React, { useState, useEffect } from 'react';
import { useLocation, Link } from "react-router-dom";
import MobileMenu from './MobileMenus';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  const navItems = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about-us' },
    { name: 'Services', href: '/services' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact Us', href: '/contacts' },
  ];

  // Check if current path matches href
  const isCurrentPage = (href) => {
    return window.location.pathname === href;
  };

  return (<>
    <header className={`top_panel top_panel_custom top_panel_custom_18617 top_panel_custom_header-main without_bg_image ${isScrolled ? 'scrolled' : ''}`}>
      <div
        data-elementor-type="cpt_layouts"
        data-elementor-id={18617}
        className="elementor elementor-18617"
      >
        {/* Desktop Header */}
        <section
          className="px-5  elementor-section elementor-top-section elementor-element elementor-element-9f71425 elementor-section-full_width elementor-section-content-middle sc_layouts_row sc_layouts_row_type_compact scheme_light sc_layouts_hide_on_tablet sc_layouts_hide_on_mobile elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
          data-id="9f71425"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f090aed sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="f090aed"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="sc_layouts_item elementor-element elementor-element-57281ed sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_logo trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="57281ed"
                  data-element_type="widget"
                  data-widget_type="trx_sc_layouts_logo.default"
                >
                  <div className="elementor-widget-container">
                    <a
                      href="/"
                      className="sc_layouts_logo sc_layouts_logo_default trx_addons_inline_15137832"
                    >
                      <img
                        loading="lazy"
                        className="logo_image"
                        src="https://d3ijvsxxdvm5iq.cloudfront.net/assets/imges/logoo-01.png"
                        alt="global logo"
                        width={173}
                        height={53}
                        style={{ maxHeight: "85px" }}



                      />
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-52f3219 sc_layouts_column_align_right sc_layouts_column sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="52f3219"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="sc_layouts_item elementor-element elementor-element-b9c2686 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_menu trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="b9c2686"
                  data-element_type="widget"
                  data-widget_type="trx_sc_layouts_menu.default"
                >
                  <div className="elementor-widget-container">
                    <nav className="sc_layouts_menu sc_layouts_menu_default sc_layouts_menu_dir_horizontal menu_hover_zoom_line">
                      <ul id="menu_main" className="sc_layouts_menu_nav menu_main_nav">
                        {navItems.map((item, index) => (
                          <li key={index} className={`menu-item menu-item-type-post_type menu-item-object-page menu-item-17194 ${isCurrentPage(item.href) ? "current_page_item current-menu-item" : ""}`}>
                            <a href={item.href} >
                              <span style={{ color: "black !important" }}>{item.name}</span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mobile Header */}
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-6358de8 elementor-section-content-middle sc_layouts_row sc_layouts_row_type_compact scheme_light sc_layouts_hide_on_wide sc_layouts_hide_on_desktop sc_layouts_hide_on_notebook elementor-section-full_width elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
          data-id="6358de8"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="d-flex align-items-center elementor-column-gap-no px-3">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-0b50d71 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="0b50d71"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="sc_layouts_item elementor-element elementor-element-4f78335 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_logo trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="4f78335"
                  data-element_type="widget"
                  data-widget_type="trx_sc_layouts_logo.default"
                >
                  <div className="elementor-widget-container">
                    <a
                      href="/"
                      className="sc_layouts_logo sc_layouts_logo_default trx_addons_inline_1098587806"
                      onClick={closeMenu}
                    >
                      <img
                        className="logo_image"
                        src="https://d3ijvsxxdvm5iq.cloudfront.net/assets/imges/logoo-01.png"
                        srcSet="https://d3ijvsxxdvm5iq.cloudfront.net/assets/imges/logoo-01.png"
                        alt="Agricola"
                        width={173}
                        height={53}
                      />
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-db1a712 sc_layouts_column_align_right sc_layouts_column sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="db1a712"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="sc_layouts_item elementor-element elementor-element-9d1d75d sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_menu trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="9d1d75d"
                  data-element_type="widget"
                  data-widget_type="trx_sc_layouts_menu.default"
                >
                  <div className="elementor-widget-container">
                    <div className="sc_layouts_iconed_text sc_layouts_menu_mobile_button_burger sc_layouts_menu_mobile_button without_menu">
                      <a
                        className={`sc_layouts_item_link sc_layouts_iconed_text_link inited_click ${isMenuOpen ? 'menu_open' : ''}`}
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleMenu();
                        }}
                      >
                        <span className="sc_layouts_item_icon sc_layouts_iconed_text_icon trx_addons_icon-menu" />
                      </a>
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mobile Menu Overlay */}
        <div className={`mobile-menu-overlay ${isMenuOpen ? 'active' : ''}`} onClick={closeMenu}></div>

        {/* Mobile Menu Sidebar */}
        <div className={`mobile-menu-sidebar ${isMenuOpen ? 'active' : ''}`}>
          <div className="mobile-menu-header">
            <button className="mobile-menu-close" onClick={closeMenu}>
              <span className="trx_addons_icon-cancel"></span>
            </button>
          </div>
          <nav className="mobile-menu-nav">
            <ul className="mobile-menu-nav-list">
              {navItems.map((item, index) => (
                <li key={index} className={`mobile-menu-item ${isCurrentPage(item.href) ? "current-menu-item" : ""}`}>
                  <a
                    href={item.href}
                    onClick={closeMenu}
                    className="mobile-menu-link"
                  >
                    <span>{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <style jsx>{`
        /* Mobile Menu Overlay */
        .mobile-menu-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          z-index: 9998;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
        }

        .mobile-menu-overlay.active {
          opacity: 1;
          visibility: visible;
        }

        /* Mobile Menu Sidebar */
        .mobile-menu-sidebar {
          position: fixed;
          top: 0;
          right: -100%;
          width: 300px;
          height: 100%;
          background: #fff;
          z-index: 9999;
          transition: right 0.3s ease;
          box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
        }

        .mobile-menu-sidebar.active {
          right: 0;
        }

        .mobile-menu-header {
          padding: 20px;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: flex-end;
        }

        .mobile-menu-close {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #333;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .mobile-menu-nav {
          flex: 1;
          padding: 20px;
          overflow-y: auto;
        }

        .mobile-menu-nav-list {
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .mobile-menu-item {
          margin-bottom: 10px;
          border-bottom: 1px solid #f5f5f5;
        }

        .mobile-menu-item:last-child {
          margin-bottom: 0;
          border-bottom: none;
        }

        .mobile-menu-link {
          display: block;
          padding: 15px 0;
          color: #333;
          text-decoration: none;
          font-size: 16px;
          font-weight: 500;
          transition: color 0.3s ease;
        }

        .mobile-menu-link:hover {
          color: var(--theme-color-text_link);
        }

        .mobile-menu-item.current-menu-item .mobile-menu-link {
          color: var(--theme-color-text_link);
          font-weight: 600;
        }

        /* Burger menu animation */
        .sc_layouts_item_icon.trx_addons_icon-menu {
          position: relative;
          width: 20px;
          height: 16px;
          display: inline-block;
        }

        .sc_layouts_item_icon.trx_addons_icon-menu:before,
        .sc_layouts_item_icon.trx_addons_icon-menu:after {
          content: '';
          position: absolute;
          left: 0;
          width: 100%;
          height: 2px;
          // background: currentColor;
          transition: all 0.3s ease;
        }

        .sc_layouts_item_icon.trx_addons_icon-menu:before {
          top: 0;
        }

        .sc_layouts_item_icon.trx_addons_icon-menu:after {
          bottom: 0;
        }

        .menu_open .sc_layouts_item_icon.trx_addons_icon-menu:before {
          transform: rotate(45deg) translate(6px, 6px);
        }

        .menu_open .sc_layouts_item_icon.trx_addons_icon-menu:after {
          transform: rotate(-45deg) translate(6px, -6px);
        }

        /* Scroll effect */
        .top_panel.scrolled {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          background: #fff;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            transform: translateY(-100%);
          }
          to {
            transform: translateY(0);
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .mobile-menu-sidebar {
            width: 280px;
          }
        }

        @media (max-width: 480px) {
          .mobile-menu-sidebar {
            width: 100%;
            right: -100%;
          }
          
          .mobile-menu-sidebar.active {
            right: 0;
          }
        }
      `}</style>
    </header>
    <MobileMenu isOpen={isMenuOpen} onClose={closeMenu} />

  </>
  );
};